import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "tag-state lg rounded-50 flex align-items-center gap-4 px-4 py-4 mb-6" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "px-3" }
const _hoisted_6 = { class: "my-1" }
const _hoisted_7 = { class: "text-sm text-grey-600" }
const _hoisted_8 = { class: "custom-upload-st2" }
const _hoisted_9 = { class: "s12" }
const _hoisted_10 = { class: "custom-upload-text-sm" }
const _hoisted_11 = { class: "custom-upload-st2" }
const _hoisted_12 = { class: "s12" }
const _hoisted_13 = { class: "custom-upload-text-sm" }
const _hoisted_14 = { class: "custom-upload-st2" }
const _hoisted_15 = { class: "s12" }
const _hoisted_16 = { class: "custom-upload-text-sm" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.userPhoto || '/public/assets/users/300w/user2.jpg',
          class: "rounded-100 overflow-hidden size-2xl",
          alt: "Photo de profil"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.userName), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userEmail) + " | " + _toDisplayString(_ctx.userCompany), 1)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "rounded-100 overflow-hidden size-2xl ml-auto" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-coop-finance.svg",
            width: "100%",
            alt: "Coop Finance"
          })
        ], -1))
      ]),
      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, " Charger vos 3 derniers bulletins de salaire ", -1)),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("label", {
          for: "file-upload-bulletin3",
          class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.bulletin3 }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", {
              id: "file-upload-bulletin3",
              name: "file-upload-bulletin3",
              type: "file",
              accept: ".pdf,.doc,.docx,.xls,.xlsx",
              onChange: _cache[0] || (_cache[0] = (e) => _ctx.handleBulletinUpload(e, 3))
            }, null, 32),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".3", -1)),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "custom-upload-text" }, "Bulletin de salaire (3)", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formData.bulletin3 ? _ctx.formData.bulletin3.name : 'Charger le doc'), 1)
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "s4 right" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "custom-upload-icon"
              })
            ], -1))
          ])
        ], 2),
        _createElementVNode("label", {
          for: "file-upload-bulletin2",
          class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.bulletin2 }])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("input", {
              id: "file-upload-bulletin2",
              name: "file-upload-bulletin2",
              type: "file",
              accept: ".pdf,.doc,.docx,.xls,.xlsx",
              onChange: _cache[1] || (_cache[1] = (e) => _ctx.handleBulletinUpload(e, 2))
            }, null, 32),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".2", -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "custom-upload-text" }, "Bulletin de salaire (2)", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formData.bulletin2 ? _ctx.formData.bulletin2.name : 'Charger le doc'), 1)
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "s4 right" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "custom-upload-icon"
              })
            ], -1))
          ])
        ], 2),
        _createElementVNode("label", {
          for: "file-upload-bulletin1",
          class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.bulletin1 }])
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("input", {
              id: "file-upload-bulletin1",
              name: "file-upload-bulletin1",
              type: "file",
              accept: ".pdf,.doc,.docx,.xls,.xlsx",
              onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleBulletinUpload(e, 1))
            }, null, 32),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".1", -1)),
            _createElementVNode("div", _hoisted_15, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "custom-upload-text" }, "Bulletin de salaire (1)", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formData.bulletin1 ? _ctx.formData.bulletin1.name : 'Charger le doc'), 1)
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "s4 right" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "custom-upload-icon"
              })
            ], -1))
          ])
        ], 2),
        _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-6" }, " Format de fichier supporté: PDF, DOC, XLS. Taille max: 5MB. ", -1)),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5 mb-6",
          disabled: _ctx.isSubmitting
        }, [
          _cache[21] || (_cache[21] = _createElementVNode("img", {
            src: "/public/icons/icon-valider.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Envoi en cours...' : 'Valider'), 1)
        ], 8, _hoisted_17),
        _createElementVNode("a", {
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToPreviousStep && _ctx.goToPreviousStep(...args)), ["prevent"])),
          class: "cursor-pointer"
        }, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("h5", { class: "flex-center gap-4 text-primary-color text-center" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-back.svg",
              class: "size-medium",
              alt: ""
            }),
            _createTextVNode(" Étape précédente ")
          ], -1)
        ]))])
      ], 32)
    ])
  ]))
}